import React, { Component } from 'react'
import { observer } from 'mobx-react'
import Modal from './Modal'
import Store from './store'

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
  }

  render() {
    const { openModal } = this.store

    return (
      <>
        <a {...this.props} onClick={openModal}>
          <span style={{ verticalAlign: 'middle' }}>店铺小程序码</span>
          <img
            style={{ marginLeft: 3 }}
            src="//qnm.hunliji.com/o_1cnofh0e01i91slu1kgo1i3bog9.png"
          />
        </a>

        <Modal store={this.store} />
      </>
    )
  }
}
